// extracted by mini-css-extract-plugin
export default {"root":"VirusDialog__root--RQHYV","title":"VirusDialog__title--1kpSG","icon":"VirusDialog__icon--25Qa1","button":"VirusDialog__button--1Zhfz","footer":"VirusDialog__footer--2idOx"};